module.exports = __webpack_public_path__ + "media/img/avatars/projects/project-2-d8dacaa4dac75725e5ced6390c3594f0.jpg";